import { API_HOST, getHttpPostOptions, getHttpGetOptions, getHttpPutOptions } from '../../utils/api-util';

const getEndpoint = () => `${API_HOST}/tribe-template`;
const getSpecificEndpoint = (externalReference) => `${getEndpoint()}/${externalReference}`;

export const getCreateTribeTemplateRequest = (tribeTemplate) => [getEndpoint(), getHttpPostOptions(tribeTemplate)];

export const getViewTribeTemplateRequest = (externalReference) => [
  getSpecificEndpoint(externalReference),
  getHttpGetOptions()
];

export const getUpdateTribeTemplateRequest = (tribeTemplate) => [getEndpoint(), getHttpPutOptions(tribeTemplate)];
